import { render, staticRenderFns } from "./WorkersAssigmentListModal.vue?vue&type=template&id=2dcd2aa4&scoped=true"
import script from "./WorkersAssigmentListModal.vue?vue&type=script&lang=js"
export * from "./WorkersAssigmentListModal.vue?vue&type=script&lang=js"
import style0 from "./WorkersAssigmentListModal.vue?vue&type=style&index=0&id=2dcd2aa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcd2aa4",
  null
  
)

/* custom blocks */
import block0 from "./resources/locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fgithub%2Fworkspace%2Fsrc%2Fcomponents%2Forder%2Fworkers-assignment-list-modal%2FWorkersAssigmentListModal.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports